import juratIcon from 'assets/img/jurat/jurat_full.png';
import { notificationTarget } from './notificationRouting';
import { notificationMessage } from './billingNotificationTime';
export { notificationTarget } from './notificationRouting';

const active = new Map();
const shown = new Set();

export const desktopNotificationPermission = () => {
  if (
    typeof window === 'undefined' ||
    typeof window.Notification !== 'function'
  )
    return 'unsupported';
  if (window.isSecureContext === false) return 'insecure';
  return window.Notification.permission;
};

// Requested automatically after login and also from the manual button; the browser may still ignore a prompt that has no user gesture.
export const enableDesktopNotifications = async () => {
  const permission = desktopNotificationPermission();
  if (permission !== 'default') return permission;
  return window.Notification.requestPermission();
};

export const showDesktopNotification = (item, openTarget) => {
  if (
    desktopNotificationPermission() !== 'granted' ||
    !item?.GUID ||
    shown.has(item.GUID)
  )
    return null;
  try {
    const notification = new window.Notification(
      item.Title || 'Jurat notification',
      {
        body: notificationMessage(item) || '',
        icon: new URL(juratIcon, window.location.origin).href,
        tag: `jurat-${item.GUID}`
      }
    );
    shown.add(item.GUID);
    if (shown.size > 500) shown.delete(shown.values().next().value);
    active.set(item.GUID, notification);
    notification.onclick = event => {
      event.preventDefault();
      window.focus();
      notification.close();
      openTarget(notificationTarget(item.ActionUrl), item.GUID);
    };
    notification.onclose = () => active.delete(item.GUID);
    return notification;
  } catch {
    // An OS/browser restriction must not interrupt the inbox or bell.
    return null;
  }
};

export const clearDesktopNotifications = () => {
  active.forEach(notification => notification.close());
  active.clear();
  shown.clear();
};
